export enum ViewCategory {
	ScheduledWork = 0,
	DigitalLogbook = 1,
	SmartDocs = 2
}
